var map = {
	"./image_1.jpg": 3611,
	"./image_10.jpg": 3123,
	"./image_11.jpg": 8358,
	"./image_12.jpg": 497,
	"./image_2.jpg": 5916,
	"./image_3.jpg": 3289,
	"./image_4.jpg": 698,
	"./image_5.jpg": 9703,
	"./image_6.jpg": 776,
	"./image_7.jpg": 1685,
	"./image_8.jpg": 2454,
	"./image_9.jpg": 3507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2771;